import React from 'react';

interface AppTooltipProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

const AppTooltip: React.FC<AppTooltipProps> = ({ title, children }) => {
  if (!title) return <>{children}</>;

  return (
    <div className="relative inline-flex items-center group/tooltip">
      {children}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 translate-y-[-8px] hidden group-hover/tooltip:flex flex-col items-center z-50 pointer-events-none">
        <div className="bg-white text-neutral-900 dark:bg-neutral-800 dark:text-neutral-100 text-xs font-medium rounded-md px-3 py-2 shadow-xl border border-neutral-200 dark:border-neutral-700 min-w-[max-content]">
          {title}
        </div>
        <div className="w-2 h-2 rotate-45 mt-[-5px] bg-white border-r border-b border-neutral-200 dark:bg-neutral-800 dark:border-neutral-700"></div>
      </div>
    </div>
  );
};

export default AppTooltip;
